// extracted by mini-css-extract-plugin
export default {"employee":"summary-info_employee__DPP5M","suffix":"summary-info_suffix__h9zVB","bold":"summary-info_bold__YGdrm","personalNumber":"summary-info_personalNumber__L7Jzz"};